import SectionStage from 'components/moduleSlides/SectionStage'

//get state of selected slide from nav (from context??)
const Slides = () => {
  return <SectionStage />
}
export default Slides
